export default __webpack_public_path__ + "static/media/search.87f11902.svg";